import { makeObservable, observable } from 'mobx'

class PurchaseOrderDesigner {
  @observable messageable = false
  @observable email = ''
  @observable id = null

  constructor (data) {
    makeObservable(this)
    Object.assign(this, data)
  }
}

export default PurchaseOrderDesigner
